import React, { useRef, useEffect, useState } from 'react'
import './Cards.css'
import card1 from '../../assets/WoodenCard.png';
import card2 from '../../assets/GoogleReview.png';
import card3 from '../../assets/GoogleReviewStand.png';
import card4 from '../../assets/TransparentPVC.png';
import card5 from '../../assets/CustomizedPVC.png';
import card6 from '../../assets/ExecutiveMetal.png';
import card7 from '../../assets/PremiumMetal.png';
import card8 from '../../assets/UltraPremiumMetal.png';
import card9 from '../../assets/googleReview2.png';
import left from '../../assets/leftArrow.svg';
import right from '../../assets/rightArrow.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import { getCurrency } from '../../utils/Utilities';

export const Cards = () => {
    const [currency, setCurrency] = useState(null);

    const [slidesToShow, setSlidesToShow] = useState(4.5);

    const data = [
      
         {
            img: card5,
            name: 'PVC NFC Cards',
            prices: {
                AED: { price: 250, dprice: 99 },
                INR: { price: 1299, dprice: 999 },
            },
            details: ['Built for business leaders who want a classy, polished card that feels professional in every meeting'],
        },
        
        {
            img: card6,
            name: 'Metal NFC Cards',
            prices: {
                AED: { price: 350, dprice: 250 },
                INR: { price: 2999, dprice: 2499 },
            },
            details: ['For people who want their business card to instantly feel premium, bold, and impossible to ignore'
                
            ],
        },
        {
            img: card7,
            name: 'Premium NFC Cards',
            prices: {
                AED: { price: 450, dprice: 350 },
                INR: { price: 3499, dprice: 2999 },
            },
            details: ['Simple, clean, and perfect for professionals who want smart networking with a stylish, modern look.'],
        },
     
        
    ];


    const formatPrice = (amount) => {
        if (currency?.currencySymbol === 'AED') {
            return ` ${amount}AED`;
        }
        return `${currency?.currencySymbol}${amount}`;
    };


    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width < 600) return 1.2;
        if (width < 1100) return 2.5;
        if (width < 1600) return 3.5;
        return 4.5;
    };

    useEffect(() => {
        setSlidesToShow(getSlidesToShow());
    }, []);

    useEffect(() => {
        const fetchCurrency = async () => {
            const result = await getCurrency();
            setCurrency(result);
            
        };
        fetchCurrency();
    }, []);

    const NextArrow = ({onClick}) => {
        return (
            <img src={right} class=" rightBtn cardsBtn" onClick={onClick}></img>
        );
    };

    
    const PrevArrow = ({onClick}) => {
         return (
            <img src={left} class="leftBtn cardsBtn" onClick={onClick}></img>
        );
    };

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1
                }
            }

        ]
    }



    return (
        <div className='cardOuter'>
            <div className='cardContent'>
                <h2 className='card_title'>Explore Our Most Premium NFC Card Collection</h2>
                <p className='cards_description' >Choose a smart NFC card that feels right for your brand. Every card is fully customized to match your style, profession, and the way you want people to remember you.</p>
                <div className='cardWrapper' >
                   {currency &&  <Slider {...settings}>
                        {data.map((item, i) => {
                            const code = currency?.currencySymbol == 'AED' ? 'AED' : 'INR';
                            const cardPrice = item.prices[code]?.price ?? item.prices['AED'].price;
                            const cardDPrice = item.prices[code]?.dprice ?? item.prices['AED'].dprice;
                            return (
                            <div className='cardBox' key={i}>
                                <div className='cards' >
                                    <div className="imgBox">
                                        <img src={item.img} alt="" />
                                        <ul className='overlay'>
                                            {item.details.map((detail, index) => (
                                                <li key={index}>{detail}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    <p className='name'>{item.name}</p>
                                    <p className='pricing'><span className='dprice'>  {formatPrice(cardPrice)}</span> {formatPrice(cardDPrice)}</p>

                                </div>
                            </div>)
                        })}
                    </Slider>}
                </div>
            </div>
        </div>
    )
}
